import React from 'react';
import { observer } from 'mobx-react';
import {
  BrowserRouter as Router, RouteComponentProps, Switch, Route
} from "react-router-dom";
import IndexMobilePayment from './IndexMobilePayment';  
import NewMobilePayment from './NewMobilePayment';
import EditMobilePayment from './EditMobilePayment';
import ViewMobilePayment from './ViewMobilePayment';

interface MobilePaymentProps extends RouteComponentProps {
  changeToggle(action?: boolean): void
}

@observer export default class MobilePayment extends React.Component<MobilePaymentProps> {
  render() {
    return (
      <Router>
        <Switch >
          <Route exact path="/pagos-movil"
            render={(props) => (
              <IndexMobilePayment {...props} changeToggle={this.props.changeToggle} />
            )}>
          </Route>
          <Route exact path="/pagos-movil/nuevo"
            render={(props) => (
              <NewMobilePayment {...props} changeToggle={this.props.changeToggle} />
            )}>
          </Route>
          <Route exact path="/pagos-movil/ver/:id"
            render={(props) => (
              <ViewMobilePayment {...props} changeToggle={this.props.changeToggle} />
            )}>
          </Route>
          <Route exact path="/pagos-movil/:id"
            render={(props) => (
              <EditMobilePayment {...props} changeToggle={this.props.changeToggle} />
            )}>
          </Route>
        </Switch>
      </Router>
    )
  }
}

